import sanityImage from '@sanity/image-url'
import {base} from '@local/config/sanity'

export const imageBuilder = sanityImage({
	projectId: base.projectId,
	dataset: base.dataset,
})
